import * as React from 'react';
import { Product } from '@packages/common';
import styled from 'styled-components';
import { HeightProps, height } from 'styled-system';
import { themeGet, media } from '@packages/ui';

import { DefaultProductPrice } from '../../ProductTile/DefaultProductPrice';
import { ProductDescription } from '../../ProductTile/ProductDescription';

export interface RecoTileBottomProps {
  product: Product;
  height?: string[];
}

export const RecoTileBottomStyled = styled.div<HeightProps>`
  ${height}
  padding:${themeGet.space(2)} ${themeGet.space(2)};
  ${media.to.md`
    padding-top: ${themeGet.space(3)}
  `}
  text-align: left;
`;

export const RecoTileBottom: React.FC<RecoTileBottomProps> = ({ product, height }) => {
  return (
    <RecoTileBottomStyled height={height}>
      <DefaultProductPrice features={product.features} price={product.price}></DefaultProductPrice>
      <ProductDescription title={product.title} my={[1]} numberOfDescriptionLines={[2]} lineHeight={[1.5, 1.5, 2]} />
    </RecoTileBottomStyled>
  );
};
